var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('a',_vm._g({directives:[{name:"test",rawName:"v-test",value:({ link: _vm.id }),expression:"{ link: id }"}],attrs:{"id":_vm.id,"href":_vm.href,"target":_vm.target}},on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_c('span',{staticClass:"wb"},[_vm._v(" "+_vm._s(_vm.tip)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }